<div class="messages-warpper">
    <div *ngFor="let message of messageService.messages$ | async" class="message-container">
        <mat-icon >{{ message.icon }}</mat-icon>
        <span class="message-text">{{ message.message }}</span>
        <button type="button" mat-icon-button color="primary" (click)="dismissMessage(message)">
            <mat-icon>
                close
            </mat-icon>
        </button>
    </div>
</div>